module.exports = __webpack_public_path__ + "img/icon-no-order.9d7fc648.png";